import React, {useRef} from 'react'
import {TableHeader} from '../../Molecules/Templates/TableHeader'
import Table from '../../Wrappers/Table'
import {TableBody} from '../Containers/TableBody'
import DropdownItem from '../../Atoms/Items/DropdownItem'
import SearchInputButton from '../../Molecules/SearchInputButton'
import PayrollProcessesTable from '../../Molecules/Tables/PayrollProcessesTable'
import PayrollSelect from '../../Molecules/Selects/PayrollSelect'
import SettlementModal from '../Modals/SettlementModal'
import ButtonContainerTableHeader from '../Containers/ButtonContainerTableHeader'
import LoadProcessButton from '../../Atoms/Buttons/LoadProcessButton'
import DropdownButton from "../../Molecules/Dropsdown/DropdownButton";

const PayrollTable = () => {
  const modal = useRef()

  const handleOpenModal = () => {
    modal.current.openModal()
  }

  const handleCloseModal = () => {
    modal.current.closeModal()
  }

  return (
    <>
      <Table.Body>
        <Table.Header>
          <PayrollSelect />

          <div className="m-cross-center s-flex-gap-12px flex-grow m-main-end s-column m-row">
            <ButtonContainerTableHeader>
              <SearchInputButton id="payroll-search" />
              <DropdownButton icon="order">
                <DropdownItem text="Id" isActive />
                <DropdownItem text="Nombre" />
                <DropdownItem text="Tipo" />
                <DropdownItem text="Empleados" />
                <DropdownItem text="Estado" />
                <DropdownItem text="Paso actual" />
              </DropdownButton>

              <DropdownButton icon="filter">
                <DropdownItem text="Activo" isActive />
                <DropdownItem text="Cerrado" />
                <DropdownItem text="Novedades" />
              </DropdownButton>
            </ButtonContainerTableHeader>

            <div className="s-order-1 m-order-2 s-cross-center s-flex-gap-12px">
              <button className="button small" disabled>
                Cierra el período
              </button>
              <button className="button small" onClick={handleOpenModal}>
                Liquidación de contrato
              </button>
            </div>
          </div>
        </Table.Header>

        <PayrollProcessesTable />

        <LoadProcessButton />
      </Table.Body>

      {/* Modal para liquidar empleados */}
      <SettlementModal handleCloseModal={handleCloseModal} ref={modal} />
    </>
  )
}

Table.Header = TableHeader
Table.Body = TableBody

export default PayrollTable
